import {PartialWorkout} from '../../Models/PartialWorkout';
import {WorkoutExecutionType} from '../../Models/WorkoutExecutionType';
import {PreviewWorkout} from '../../Models/PreviewWorkout';

export function workoutTitleFormatter(workout: PartialWorkout | PreviewWorkout): string {
    if (workout.title !== null && workout.title !== '') {
        return workout.title;
    }
    if (workout.training_plan) {
        return workout.training_plan.title;
    }

    if (workout.execution_type === WorkoutExecutionType.OUTDOOR) {
        return 'Outdoor Session';
    }

    return 'Quick Session';
}
